import { ShipmentLocked, SecurePassStatus, SECURE_PASS_TAG_STATUS } from "@/utils/enum";
export var TrailerType;
(function (TrailerType) {
    TrailerType[TrailerType["Open"] = 1] = "Open";
    TrailerType[TrailerType["Enclosed"] = 2] = "Enclosed";
})(TrailerType || (TrailerType = {}));
export var ShipmentStatus;
(function (ShipmentStatus) {
    ShipmentStatus[ShipmentStatus["Draft"] = 1] = "Draft";
    ShipmentStatus[ShipmentStatus["Pending"] = 2] = "Pending";
    ShipmentStatus[ShipmentStatus["Completed"] = 3] = "Completed";
    ShipmentStatus[ShipmentStatus["Posted"] = 4] = "Posted";
    ShipmentStatus[ShipmentStatus["Assigned"] = 5] = "Assigned";
    ShipmentStatus[ShipmentStatus["Delivered"] = 6] = "Delivered";
    ShipmentStatus[ShipmentStatus["Incomplete"] = 7] = "Incomplete";
})(ShipmentStatus || (ShipmentStatus = {}));
export var DealerExchange;
(function (DealerExchange) {
    DealerExchange[DealerExchange["Ordered"] = 1] = "Ordered";
    DealerExchange[DealerExchange["Unordered"] = 2] = "Unordered";
})(DealerExchange || (DealerExchange = {}));
export var IntegrationType;
(function (IntegrationType) {
    IntegrationType[IntegrationType["WWL"] = 1] = "WWL";
})(IntegrationType || (IntegrationType = {}));
export var ShipmentIncompleteStatus;
(function (ShipmentIncompleteStatus) {
    ShipmentIncompleteStatus[ShipmentIncompleteStatus["NOT_APPLICABLE"] = 1] = "NOT_APPLICABLE";
    ShipmentIncompleteStatus[ShipmentIncompleteStatus["INCIDENT"] = 2] = "INCIDENT";
    ShipmentIncompleteStatus[ShipmentIncompleteStatus["MISINFORMATION"] = 3] = "MISINFORMATION";
    ShipmentIncompleteStatus[ShipmentIncompleteStatus["NOT_AVAILABLE"] = 4] = "NOT_AVAILABLE";
    ShipmentIncompleteStatus[ShipmentIncompleteStatus["CANCELLED"] = 5] = "CANCELLED";
    ShipmentIncompleteStatus[ShipmentIncompleteStatus["DRY_RUN"] = 6] = "DRY_RUN";
    ShipmentIncompleteStatus[ShipmentIncompleteStatus["EXCHANGE_SET_TO_INCOMPLETE"] = 7] = "EXCHANGE_SET_TO_INCOMPLETE";
})(ShipmentIncompleteStatus || (ShipmentIncompleteStatus = {}));
